import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { useLocation, useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import axios from "axios";
import EventList from "./components/EventList";
import Person from "./components/Person";
import CircularProgress from "@mui/material/CircularProgress";

const Events = props => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;
    const { api, comp } = itemOptions;
    const { t } = i18n;
    const location = useLocation();
    const navigate = useNavigate();

    const state = location.state;
    const [loading, setLoading] = useState(false);
    const [fetched, setFetched] = useState(false);
    const [uuid, setUuid] = useState("");
    const [avCategories, setAvCategories] = useState([]);
    const [regEntries, setRegEntries] = useState([]);
    const [code, setCode] = useState("");

    const fetchCategories = function(uuid, entries) {
        setUuid(uuid);
        setRegEntries(entries);
        axios
            .get(`${api.getAvailableCategoriesForEntryAnonymously}${uuid}`)
            .then(function(response) {
                // console.log(response);
                setAvCategories(response.data);
                setLoading(false);
                setFetched(true);
            })
            .catch(function(error) {
                setLoading(false);

                console.log(error);
            });
        setLoading(false);
    };
    useEffect(() => {
        if (state === null) {
            navigate("/");
        } else {
            setLoading(true);
            setCode(state.code);
           // console.log(state);
            axios
                .get(`${api.getAvailableEventsForPersonAnonymously}${comp.id}/${state.person.personId}`)
                .then(function(response) {
                    // console.log(response.data);
                    setAvCategories(response.data.available);
                    setRegEntries(response.data.registered);

                    setLoading(false);
                    setFetched(true);
                })
                .catch(function(error) {
                    setLoading(false);

                    console.log(error);
                });
        }
    }, [state]);
    return (
        <React.Fragment>
            <hr />
            <h2 className="display-6 mt-2">{t("reg.events")}</h2>
            <p>{t("reg.info.events")}</p>

            <Container maxWidth="xs" className="mb-2">
                {fetched && <Person person={state.person} />}
                {loading && (
                    <Stack spacing={1}>
                        <Skeleton variant="rectangular" height={60} />
                        <Skeleton variant="rectangular" height={60} />
                        <Skeleton variant="rectangular" height={60} />
                    </Stack>
                )}
            </Container>
            <Container maxWidth="xs" className="mb-2">
                {fetched && <EventList code={code} events={avCategories} registered={regEntries} person={state.person} api={api} />}
                {!fetched && <CircularProgress />}
            </Container>
        </React.Fragment>
    );
};

export default Events;
